<template>
    <v-dialog v-model="dialog" @keydown.esc="cancel" max-width="500px">
        <v-card elevation="0">
            <v-card-title class="red--text">
                <v-icon dense class="pr-2" color="red">mdi-alert</v-icon>
                    Alerta
                <v-spacer></v-spacer>
                            <v-btn 
                                color="grey"
                                plain
                                @click="cancel"
                                class="ma-1"
                            ><v-icon left>mdi-close</v-icon>Fechar</v-btn>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <p class="ma-2 text-sm-body-2">{{ message }}</p>
            </v-card-text>
            <v-divider/>
            <v-card-actions class="pa-4">
                <v-spacer/>
                <v-btn color="primary"
                    elevation="0"
                    large
                    outlined
                    rounded 
                    @click="cancel">
                    <v-icon small left>mdi-close</v-icon>
                    CANCELAR</v-btn>
                <v-btn color="primary"
                    elevation="0"
                    large
                    outlined
                    rounded 
                    @click="confirm">
                    <v-icon small left>mdi-check</v-icon>
                    CONFIRMAR</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:'ConfirmDialog',
    data(){
        return {
            dialog: false,
            message: null,
            title: null,
            resolve: null,
            reject: null,
        }
    },
    methods:{
        open(title, message){
            this.dialog = true;
            this.title = title;
            this.message = message;
            return new Promise((resolve, reject)=>{
                this.resolve = resolve
                this.reject = reject
            })
        },
        cancel() {
            this.resolve(false);
            this.dialog = false;
        },
        confirm() {
            this.resolve(true);
            this.dialog = false;
        }
    }
}
</script>
<style scoped>
 
</style>